import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {greyishBlue50} from "assets/jss/main";

ToggleNavigation.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func.isRequired,
    fullWidth: PropTypes.bool
};

/** @deprecated: use src/components/Toggle/ToggleNavigation.js **/
function ToggleNavigation({value, onChange, withoutBackground = false, withChildMargin = false, autoMargin = false, fullWidth = false, ...props}) {
    return (
        <div style={{
            background: withoutBackground ? "transparent" : greyishBlue50,
            display: 'flex',
            width: fullWidth ? '100%' : 'fit-content',
            border: `0px solid ${greyishBlue50}`,
            borderRadius: '8px',
            margin: autoMargin ? "auto" : "none",
        }}>
            {props.children.map((toggle, index) => (
                <div
                    key={index}
                    style={{
                        marginRight: withChildMargin ? '8px' : '0',
                        width: fullWidth ? '100%' : 'fit-content',
                    }}
                >
                    {React.cloneElement(toggle, {
                        checked: value === index,
                        onClick: () => onChange(index),
                    })}
                </div>
            ))}
        </div>
    );
}

export default ToggleNavigation;
